import { Button } from "@src/components/elements";
import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  overflow: auto;
`;
interface Props {
  showCount: boolean;
  countLabel: string;
  pageLength: number;
  pageIndex: number;
  pageSize: number;
  pageCount: number;
  pageOptions: number[];
  dataLength: number;
  onClickPrevPage: () => void;
  onClickNextPage: () => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
  onClickPageNum: (pageIndex: number) => void;
  onClickShowAllPages: () => void;
}

export const TablePagination: React.FC<Props> = ({
  showCount,
  countLabel,
  pageLength,
  pageIndex,
  pageSize,
  pageCount,
  pageOptions,
  dataLength,
  onClickPrevPage,
  onClickNextPage,
  canPreviousPage,
  canNextPage,
  onClickPageNum,
  onClickShowAllPages,
}) => {
  return (
    <StyledRoot className="pagination">
      {showCount && countLabel && !!pageLength && (
        <div className="pagination-count">{`${pageIndex * pageSize + 1} to ${
          pageIndex * pageSize + pageLength
        } of ${dataLength} ${countLabel}`}</div>
      )}
      {pageCount > 1 && (
        <div className="pagination-nav">
          <Button
            size="small"
            variant="tertiary"
            onClick={() => {
              onClickPrevPage();
            }}
            disabled={!canPreviousPage}
            title="previous page"
          >
            {"<"}
          </Button>{" "}
          <Button
            size="small"
            variant="tertiary"
            onClick={onClickNextPage}
            disabled={!canNextPage}
            title="next page"
          >
            {">"}
          </Button>{" "}
          <Button
            size="small"
            variant="tertiary"
            onClick={onClickShowAllPages}
            title="view all"
            nowrap={true}
          >
            View all
          </Button>
          {pageOptions.map((pageOption) => {
            const btn = (
              <Button
                size="small"
                variant="tertiary"
                active={pageIndex === pageOption}
                key={pageOption}
                onClick={() => {
                  onClickPageNum(pageOption);
                }}
              >
                {pageOption + 1}
              </Button>
            );
            return btn;
          })}
        </div>
      )}
    </StyledRoot>
  );
};
